import { TransactionType } from "../../utils";

export const FILTER_OPTIONS = [
  { label: "All time", value: "all" },
  { label: "Last 7 days", value: "7d" },
  { label: "Last 30 days", value: "30d" },
  { label: "Last 6 months", value: "6m" },
  { label: "Yearly", value: "year" },
  { label: "Monthly", value: "month" },
];

export const FILTER_MONTHS = [
  { label: "Jan", value: "1" },
  { label: "Feb", value: "2" },
  { label: "Mar", value: "3" },
  { label: "Apr", value: "4" },
  { label: "May", value: "5" },
  { label: "Jun", value: "6" },
  { label: "Jul", value: "7" },
  { label: "Aug", value: "8" },
  { label: "Sep", value: "9" },
  { label: "Oct", value: "10" },
  { label: "Nov", value: "11" },
  { label: "Dec", value: "12" },
];

export const TRANSACTION_TYPES = [
  { label: "All", value: TransactionType.ALL },
  { label: "Income", value: TransactionType.INCOME },
  { label: "Expense", value: TransactionType.EXPENSE },
  { label: "Transfer", value: TransactionType.TRANSFER },
  { label: "Loan Payment", value: TransactionType.LOAN_PAYMENT },
  { label: "Category", value: "Category" },
];

// Idea for Categories with Icons
export const DEFAULT_CATEGORIES = [
  { id: 1, name: "Food & Dining", icon: "🍽️" },
  { id: 2, name: "Transportation", icon: "🚗" },
  { id: 3, name: "Shopping", icon: "🛍️" },
  { id: 4, name: "Entertainment", icon: "🎬" },
  { id: 5, name: "Bills & Utilities", icon: "📋" },
  { id: 6, name: "Healthcare", icon: "🏥" },
  { id: 7, name: "Education", icon: "📚" },
  { id: 8, name: "Travel", icon: "✈️" },
  { id: 9, name: "Income", icon: "💰" },
  { id: 10, name: "Investments", icon: "📊" },
];

// Sort options --- MAYBE FOR MOBILE?!?!?
export const SORT_OPTIONS = [
  { label: "Date (Newest first)", value: "date_desc" },
  { label: "Date (Oldest first)", value: "date_asc" },
  { label: "Amount (Highest first)", value: "amount_desc" },
  { label: "Amount (Lowest first)", value: "amount_asc" },
  { label: "Category", value: "category" },
];
